var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"label":_vm.$t(_vm.tooltipLabel),"position":"is-right"}},[_c('span',{staticClass:"rounded-full",class:[_vm.statusColor, 'w-'+_vm.size, 'h-'+_vm.size, 'inline-block']})])
}
var staticRenderFns = []

export { render, staticRenderFns }